<template><div>
  <div style="width: 80%;margin: auto; background-color: antiquewhite;">
    <div style="padding: 30px;">
  <el-form :model="parameter" :rules="rules" ref="ruleForm" label-width="250px" class="demo-ruleForm">
  <el-form-item label="选择部门" prop="departmentId">
    <el-select v-model="parameter.departmentId" placeholder="请选择部门">
      <el-option :label="item.name" :value="item.id" v-for="item in deptlist" :key="item.id"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="选择时间" prop="isWeeks">
  <el-select v-model="value" placeholder="考核年份" @change="handChange">
          <el-option
            v-for="item in year"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
        <el-select v-model="value3" placeholder="考核月份" @change="handChange">
          <el-option
            v-for="item in moun"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
        <el-select v-model="parameter.isWeeks" placeholder="第几周" @change="handChange">
          <el-option
            v-for="item in week"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
    <el-form-item label="工号" prop="workNumber">
      <el-input v-model="parameter.workNumber"  @blur="workNumberChange" oninput="value=value.replace(/[^0-9]/g, '');if(value.length>=6)value=value.slice(0,6)"  maxlength="6" type="number" ></el-input>
    </el-form-item>
    <el-form-item label="姓名" prop="userName">
      <el-input v-model="parameter.userName" oninput="if(value.length>=20)value=value.slice(0,20)"    maxlength="20"></el-input>
    </el-form-item>

    <el-form-item label="服务学院教学和日常运行"  prop="teachingOperation">
      <el-input v-model="parameter.teachingOperation" placeholder="是/否"  oninput="if(value.length>=6)value=value.slice(0,6)"   maxlength="200"></el-input>
    </el-form-item>
    <el-form-item label="服从学院各项工作安排" prop="obeyArrange">
      <el-input v-model="parameter.obeyArrange" placeholder="是/否"  maxlength="200"></el-input>
    </el-form-item>
    <el-form-item label="全英文交流" prop="englishExchange">
      <el-input v-model="parameter.englishExchange"  placeholder="是/否"  maxlength="200"></el-input>
    </el-form-item>
    <el-form-item label="与英方合作团队保持有效工作沟通" prop="cooperationExchange">
      <el-input v-model="parameter.cooperationExchange"  placeholder="是/否"   maxlength="200"></el-input>
    </el-form-item>

    <el-form-item label="学生、家长或学院其他部门投诉" prop="userComplaints">
      <el-input v-model="parameter.userComplaints"  placeholder="学生及家长投诉次数/学院其他部门投诉次数（如0/2）"   maxlength="200"></el-input>
    </el-form-item>
    <el-form-item label="附件" prop="annexFileUrl">
      <el-upload
      :headers="headers"
  action="thu_api/performance/file"
  list-type="picture-card"
  :on-remove="handleRemove"
  :on-success="handSuccess"
  :file-list="fileList"
  :on-change="handleChange"
  :before-upload="beforeAvatarUpload"
    accept=".jpg,.jpeg,.png,.gif,.pdf"
  >
  <i class="el-icon-plus"></i>
</el-upload>
<el-dialog :visible.sync="dialogVisible">
  <img width="100%" :src="dialogImageUrl" alt="">
</el-dialog>
    </el-form-item>
    <el-form-item label="备注" prop="remark">
      <el-input
  type="textarea"
  placeholder="请输入内容"
  v-model="parameter.remark"
  maxlength="255"
  show-word-limit
></el-input>
    </el-form-item>
    <el-form-item>
    <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
    <el-button @click="resetForm('ruleForm')">重置</el-button>
  </el-form-item>
  </el-form>
</div>
</div>
</div>
</template>
  <script>
    export default {
      data() {
        var check = (rule, value, callback) => {
          let va=value.split('/')
          if(va.length==1){
            callback(new Error("缺乏/"))
          }else if(va.length==2){
            if(this.isEmptyStr(va[0])||this.isEmptyStr(va[1])){
              callback(new Error("/左右不能为空")) 
            }else{
           this.checkVal(rule, value, callback,va)
             
            }
          }else{
            callback(new Error("/过多"))
          }
         
    }

    var checkWrited = (rule, value, callback) => {
      if(!(this.value==null||this.value3==''||this.parameter.isWeeks=='')){
            let kpidate=this.value+'-'+(this.value3>9?this.value3:'0'+this.value3)
            this.parameter.writeDate=kpidate
          }else{
            this.parameter.writeDate=null
            return false
          }
     if( this.parameter.writeDate!=null&&this.parameter.workNumber!=''&&this.parameter.workNumber!=null){
      this.axios.post("/performance/getWrited",this.parameter).then(res=>{
                console.log(res)
                if(res.data[0].total>0){
                  callback(new Error("本周已写"))
                }else{
                  callback()  
                }
              })
     }else{
      return false
     }
    }

    var isTrue=(rule, value, callback) => {
       if(value.includes('是')||value.includes('否')){
        console.log('value',value)
        callback();
       }else{
        callback(new Error('请填写是或者否'))
       }
    }
        return {
          fileList:[],
          headers:{ 'token': localStorage.getItem('token')},
          dialogImageUrl: '',
          dialogVisible: false,
          week:[1,2,3,4],
          deptlist:[],
          value: '',
        value3: '',
        year:[],
        moun:[],
          parameter: {
            departmentId:2,
            workNumber:'',
            userName:'',
            teachingOperation: '',
            obeyArrange: '',
            englishExchange: '',
            cooperationExchange: '',
            userComplaints:'',
            writeDate:'',
            remark:'',
            isWeeks:'',
            annexFileUrl:'',
          },
          rules: {
            workNumber: [
              { required: true, message: '请输工号', trigger: 'blur' },
              { min: 6, max: 6, message: '长度在6 个字符', trigger: 'blur' },
              { validator: checkWrited, trigger: 'blur' },
            ],departmentId: [
              { required: true, message: '请选择部门', trigger: 'blur' },
            ],userName: [
              { required: true, message: '请输入名字', trigger: 'blur' },
              { min: 2, max: 20, message: '长度在2-20个字符', trigger: 'blur' }
            ],teachingOperation: [
              { required: true, message: '请输入服务学院教学和日常运行', trigger: 'blur' },
              { validator: isTrue, trigger: 'blur' },
            ],obeyArrange: [
              { required: true, message: '服从学院各项工作安排', trigger: 'blur' },
              { validator: isTrue, trigger: 'blur' },
            ],englishExchange: [
              { required: true, message: '请输入全英文交流', trigger: 'blur' },
              { validator: isTrue, trigger: 'blur' },
            ],cooperationExchange: [
              { required: true, message: '请输入与英方合作团队保持有效工作沟通', trigger: 'blur' },
              { validator: isTrue, trigger: 'blur' },
            ],writeDate: [
              { required: true, message: '请选择时间', trigger: 'blur' },
            ],
            userComplaints: [
              { required: true, message: '请填写学生、家长或学院其他部门投诉', trigger: 'blur' },
              { validator: check, trigger: 'blur' },
            ],annexFileUrl: [
              { required: true, message: '请选择附件', trigger: 'blur' },
            ],
            isWeeks: [
            { required: true, message: '请选择时间', trigger: 'blur' },
            { validator: checkWrited, trigger: 'change' },
            ],
         
          },

        };
      },
      created(){
        this.getDept()
        this.getYearDateList()
        this.getMonthlIST()
      },
      methods: {        beforeAvatarUpload(file) {
          let isImage=  this.$formateDate.isImageFile(file)
          let isPdf=  this.$formateDate.isPdfFile(file)
           if(isImage||isPdf){
            return true
           }else{
            this.$message.error('只能上传图片和pdf!');
            return false
           }
      },
        handChange(){
         this.$refs.ruleForm.validateField('workNumber')
        },
        workNumberChange(){
          this.$refs.ruleForm.validateField('isWeeks')
        },
        handleRemove(file, fileList) {
          this.fileList = fileList.slice(-3);
        console.log(file, fileList);
      },
      handSuccess(response, file, fileList){
      console.log('fileList',fileList)
      },  handleChange(file, fileList) {
        console.log('handleChange',fileList)
        this.fileList = fileList.slice(-3);
      },
        submitForm(formName) {
          if(this.fileList.length<=0){
            this.parameter.annexFileUrl=null
          }else{
         let files= this.fileList.map(res=>{
              return res.response
            })
            this.parameter.annexFileUrl=JSON.stringify(files)
          }
          if(!(this.value==null||this.value3==''||this.parameter.isWeeks=='')){
            let kpidate=this.value+'-'+(this.value3>9?this.value3:'0'+this.value3)
            this.parameter.writeDate=kpidate
          }else{
            this.parameter.writeDate=null
          }
          this.$refs[formName].validate((valid) => {
            if (valid) {
             
              this.axios.post("/performance/administrative/add",this.parameter).then(res=>{
                if(res.data.status==1){
                  this.$message.success("添加成功");
                  // this.resetForm('ruleForm')
                }else{
                  this.$message.error(res.data.message);

                }
              })


            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        resetForm(formName) {
          this.$refs[formName].resetFields();
        },getDept(){
          this.axios.get("/performance/getDept")
          .then(resp => { 
            this.deptlist=resp.data
         console.log(resp)
          })
        },  getYearDateList(){
      var date = new Date()
    var Y = date.getFullYear()
    console.log(Y)
   let yearList=[]
   yearList.push(Y-1)
   yearList.push(Y)
   yearList.push(Y+1)
    this.value=Y
   this.year=yearList
       }, isEmptyStr(s) {
	if (s == undefined || s == null || s == '') {
		return true
	}
	return false
},
       getMonthlIST(){
        var date = new Date()
        var M = (date.getMonth() + 1)
        this.value3=M
        let mounList=[]
        for (let index = 1; index <13; index++) {
        mounList.push(index)  
        }
      this.moun=mounList
      // this.value3=M
       },checkCharacter(char) {
    const charCode = char.charCodeAt(0); // 获取字符的ASCII码值
    if (charCode >= 48 && charCode <= 57) { // ASCII码中，数字48-57对应的字符是0-9
        return true;
    } else {
      return false
    }
},checkVal(rule, value, callback,va){
  if(rule.field=='obeyArrange'||rule.field=='englishExchange'||rule.field=='userComplaints'){
    if(!this.checkCharacter(va[0])){   callback(new Error("/左边格式不正确，应为数字类型")) }
    if(!this.checkCharacter(va[1])){   callback(new Error("/右边格式不正确，应为数字类型")) }
               
  }
  callback();
}
      }
    }
  </script>


// WEBPACK FOOTER //
// src/components/work/administrative/APerformance.vue